export enum ReviewStatus {
  COMPLETED = 'Completed',
  DRAFT = 'Draft',
  IN_PROGRESS = 'In Progress',
  PENDING = 'Pending',
}

export enum ReviewButton {
  CANCEL = 'CANCEL',
  FINAL_REVIEW = 'FINAL REVIEW',
  SAVE_PENDING = 'SAVE PENDING',
  SAVE_REVIEW = 'SAVE REVIEW',
}

export enum PhysicianPaRecommendationValues {
  NO = 'No',
  NOT_SELECTED = 'NotSelected',
  YES = 'Yes',
}

export enum PhysicianResponseType {
  NO_RESPONSE = 'NoResponse',
  NOT_SELECTED = 'NotSelected',
  SPOKE_WITH_PHYSICIAN = 'SpokeWithPhysician',
}

export enum PhysicianContactProperties {
  PHYSICIAN_COMMENTS = 'physicianComments',
  PHYSICIAN_CONTACT = 'physicianContact',
  PHYSICIAN_CONTACTED_DATE = 'physicianContactedDate',
  PHYSICIAN_PA_RECOMENDATION = 'physicianPaRecommendation',
  PHYSICIAN_RESPONSE_TYPE = 'physicianResponseType',
}

export enum PeerToPeerScheduleOptions {
  PA_TO_SCHEDULE_PEER_TO_PEER = 'PA to Schedule Peer-To-Peer',
  PEER_TO_PEER_PENDING_SCHEDULED = 'Peer-To-Peer Pending Schedule',
  PEER_TO_PEER_SCHEDULED = 'Peer-To-Peer Scheduled',
}

export const ESCALATION_MISSING_USER_MESSAGE =
  'Please select a user to escalate this review to.';
